import { BehaviorSubject } from 'rxjs';
import { socketIO } from '../../socket';

// const socketIO = io(process.env.REACT_APP_NOTIFICATION_ENDPOINT);

export const socketData = new BehaviorSubject(null);
// socketData.subscribe(value => {
//     console.log('subscribe123', value);
// })

export default () => {
  const setSocketData = (eventName, data) => {
    if (socketData.value !== { eventName, data }) {
      socketData.next({ eventName, data });
    }
  };
  function onNotificationEvent(value) {
    setSocketData('notification', value);
  }

  function onConnect(value) {
    setSocketData('connect', value);
  }

  function onDisconnect(value) {
    setSocketData('disconnect', value);
  }

  socketIO.on('connect', onConnect);
  socketIO.on('disconnect', onDisconnect);
  socketIO.on('notification', onNotificationEvent);

  // socketIO.off('connect', onConnect);
  // socketIO.off('disconnect', onDisconnect);
  // socketIO.on('notification', onNotificationEvent);

  return socketData;
};
